import noodleApiClient, { ApiDefinition } from '@noodleApi';

type THIS_API = ApiDefinition['/payments/processing-fees']['GET'];
type Input= THIS_API['query'];
type Output = THIS_API['response'];

const getProcessingFees = async ({ amount, isConfido, stripeAccountType }: Input): Promise<Output> => {
  const params : Input ={ amount, isConfido };
  if(stripeAccountType) {
    params.stripeAccountType=stripeAccountType;
  }
  const response = await noodleApiClient.get(`/payments/processing-fees`, { params });
  return response.data;
};

export default getProcessingFees;